// extracted by mini-css-extract-plugin
export default {"container":"sP-z","topReviewHeading":"tP-z","criticalReview":"uP-z","favorableReview":"vP-z","vsSeparator":"wP-z"};